import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

interface ReceivablesRowSkeletonProps {
    count: number;
    testId: string;
}

/** Placeholder tiles the size of a `ReceivablesTile`, so the content below does not shift once the figures land. */
export const ReceivablesRowSkeleton: React.FC<ReceivablesRowSkeletonProps> = ({ count, testId }) => (
    <div data-testid={testId} aria-hidden="true" className="flex gap-xs">
        {Array.from({ length: count }, (_, index) => (
            <div key={index} className="flex h-[50px] w-[130px] flex-col justify-center gap-0.5 rounded-md bg-surface-secondary px-s">
                <div className="flex h-4 items-center"><SkeletonBar className="h-3 w-20" /></div>
                <div className="flex h-4 items-center"><SkeletonBar className="h-3 w-16" /></div>
            </div>
        ))}
    </div>
);
